import { useState } from 'react';
import ModuleSection from '../ModuleSection';
import DistrictMap from './DistrictMap';
import DistrictPanel from './DistrictPanel';
import MapFullscreen from './MapFullscreen';
import NationalResult from './NationalResult';
import { MAP_DATA } from '../../lib/buildMapPaths';
import { resolveSectionProps, useSectionText } from '../../lib/useSectionText';
import './MapModule.css';

const DEFAULTS = {
  number: '03',
  kicker: '2022 Results',
  title: (
    <>
      How the <em>Last</em> Vote Went
    </>
  ),
  intro:
    'The 2022 general election by district — vote share, margins, who got elected. Tap any district to see the full breakdown. Districts shaded by margin: deep red and deep blue mean safe seats, pale shades mean tight races.',
};

export default function MapModule() {
  // Default to D12 — the closest 2022 result, the most editorially interesting
  // auto-selection.
  const [active, setActive] = useState<number | null>(12);
  const [fullscreen, setFullscreen] = useState(false);
  const sectionText = useSectionText('map');

  const activeDistrict =
    active != null ? (MAP_DATA.paths.find((p) => p.id === active) ?? null) : null;

  return (
    <ModuleSection
      {...resolveSectionProps(DEFAULTS, sectionText)}
      id="map"
    >
      <div className="map-module">
        <div className="map-module__map-shell">
          <NationalResult />
          <DistrictMap active={active} onSelect={setActive} />
          <button
            type="button"
            className="expand-btn map-module__expand"
            onClick={() => setFullscreen(true)}
            aria-label="Expand map to full screen"
            title="Expand to full screen"
          >
            <span className="expand-btn__icon" aria-hidden="true">
              ⤢
            </span>
            <span>Expand</span>
          </button>
        </div>

        <DistrictPanel district={activeDistrict} />
      </div>

      {fullscreen && (
        <MapFullscreen
          active={active}
          onSelect={setActive}
          district={activeDistrict}
          onClose={() => setFullscreen(false)}
        />
      )}
    </ModuleSection>
  );
}
